import mixpanel from 'mixpanel-browser'

const TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN

// Ensure we only init once per page-load.
const INIT_FLAG = '__HF_MIXPANEL_INITIALIZED__'

export function initMixpanel() {
  if (!TOKEN) return false
  if (typeof window === 'undefined') return false
  if (window[INIT_FLAG]) return true

  window[INIT_FLAG] = true

  // Prefer localStorage persistence to better match SPA behavior.
  // Keep autocapture off by default to reduce risk of unintended capture.
  mixpanel.init(TOKEN, {
    persistence: 'localStorage',
    debug: Boolean(import.meta.env.DEV),
    track_pageview: false,
    autocapture: false,
    stop_utm_persistence: true,
  })

  return true
}

export function trackPageView({ pathname, search, hash, title } = {}) {
  if (!initMixpanel()) return

  // Use track_pageview() for Mixpanel's default $mp_web_page_view event.
  // Attach a couple useful props for analysis.
  mixpanel.track_pageview({
    pathname: pathname ?? window.location.pathname,
    search: search ?? window.location.search,
    hash: hash ?? window.location.hash,
    title: title ?? document.title,
  })
}

export function identifyUser(me) {
  if (!initMixpanel()) return
  if (!me?._id) return

  mixpanel.identify(String(me._id))

  // Attach org context as super properties so it flows with all events.
  if (me?.activeOrg?._id) {
    mixpanel.register({
      org_id: String(me.activeOrg._id),
      org_member: me.activeOrg.member,
      org_name: me.activeOrg.name,
    })
  }

  // Best-effort people profile.
  try {
    mixpanel.people.set({
      user_id: String(me._id),
      email: me.email || me.username,
      first_name: me?.profile?.firstname,
      last_name: me?.profile?.lastname,
    })
  } catch (_e) {
    // ignore
  }
}

export function resetMixpanel() {
  if (!initMixpanel()) return
  mixpanel.reset()
}

